type ProWelcomeController = {
  open: () => void;
  close: () => void;
};

let controller: ProWelcomeController | null = null;

/** Brief “you’re on Pro” moment after Checkout — not the Settings sheet. */
export function registerProWelcomeController(next: ProWelcomeController | null): void {
  controller = next;
}

export function openProWelcome(): boolean {
  if (!controller) return false;
  controller.open();
  return true;
}

export function closeProWelcome(): boolean {
  if (!controller) return false;
  controller.close();
  return true;
}
